import type { AppStatus } from '../Apps.types'

export const isAppConnected = (status: AppStatus) => {
  if (status === true) return true

  const CONNECTED_STATUSES: AppStatus[] = ['CONNECTED', 'NOT_CONFIGURED', 'SYNCING']

  return CONNECTED_STATUSES.includes(status)
}
